var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.80778C7 6.46523 9.00971 8.21821 10.4809 9.2794C10.6788 9.42214 10.8473 9.54369 11 9.64402V12.4092C9.47046 11.2438 7.36341 11.0186 6.10698 11.0001C5.47713 10.9909 4.99079 11.461 5.00013 12.0701C5.02059 13.4043 5.29862 15.7304 6.83869 17.2202C8.00356 18.347 9.66339 18.7758 11 18.9266V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V18.9266C14.3366 18.7758 15.9964 18.347 17.1613 17.2202C18.7014 15.7304 18.9794 13.4043 18.9999 12.0701C19.0092 11.461 18.5229 10.9909 17.893 11.0001C16.6366 11.0186 14.5295 11.2438 13 12.4092V9.64403C13.1527 9.54369 13.3212 9.42215 13.5191 9.2794C14.9903 8.21823 17 6.46525 17 4.80776C17 2.03888 14.2499 1.00511 12 3.14405C9.75008 1.00511 7 2.03888 7 4.80778Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerAlt2);
export default __webpack_public_path__ + "static/media/flower-alt-2.c03ce89a85fe261e46f20ebeff64abd8.svg";
export { ForwardRef as ReactComponent };